<template>
<v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
        <jur-form :init-jur-id="jurId"
                  :init-is-show-jur-prefetch="isShowJurPrefetch"
                  @created="onCreatedJur"
        />
    </v-card-text>
</v-card>
</template>

<script>
import JurForm from "../../components/contragents/JurForm.vue";

export default {
    name: "JurEditPage",
    components: {JurForm},
    methods: {
        onCreatedJur(jur){
            this.$router.push({name: 'JurEditPage', params: { id: jur.id }});
        }
    },
    computed: {
        jurId(){
            if('id' in this.$route.params){
                return this.$route.params.id
            }
            return null;
        },
        isShowJurPrefetch(){
            return this.jurId === null;
        },
        title(){
            return this.jurId === null ? 'Создание юридического лица' : 'Редактирование юридического лица';
        },
    }
}
</script>

<style scoped>

</style>